import { PrivacyPolicyTemplate } from "../../Templates/PrivacyPolicyTemplate";

export const PrivacyPolicy = () => {
  return <PrivacyPolicyTemplate />;
};
